import PageHero from "@/components/feature/PageHero";
import Story from "./components/Story";
import Facilities from "./components/Facilities";
import Equipment from "./components/Equipment";

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About Bianca"
        title="비앙카를 소개합니다"
        description="10년의 경험과 진심을 담아, 고객님의 피부에 꼭 맞는 관리를 제공하는 비앙카 피부관리입니다."
        image="https://readdy.ai/api/search-image?query=Soft%20elegant%20skincare%20spa%20hero%20background%20in%20dusty%20pink%20and%20cream%20tones%20with%20delicate%20floral%20accents%20and%20gentle%20flowing%20shapes%20minimalist%20serene%20luxurious%20atmosphere%20bright%20high%20key%20editorial%20aesthetic&width=1920&height=700&seq=bianca-about-hero&orientation=landscape"
      />
      <Story />
      <Facilities />
      <Equipment />
    </>
  );
}